<template>
  <div class="page-wrapper">
    <div class="page-content">
      <div class="page-content__meta d-flex f-between">
        <h1 class="page-title">{{ currentPost.title }}</h1>
        <div class="page-breadcrumb">
          <BreadCrumb />
        </div>
      </div>

      <div class="news-meta">
        <span class="news-type">новости</span>
        <i class="news-date">{{ currentPost.date }}</i>
      </div>

      <div class="show-news-wrap">
        <div class="page-banner negative-margin ratio2by09">
          <div class="page-banner-image p-absolute w-100 h-100">
            <img class="d-block img-cover" :src="currentPost.bigImg" alt="Banner" />
          </div>
        </div>

        <div class="news-text-wrap">
          <p>{{ currentPost.desc }}</p>
        </div>

        <!-- <div class="news-text-wrap">
          <p>
            Покупка квартиры — ответственное и хлопотное дело. Каждый покупатель
            знает хотя бы приблизительно, какое жилье в собственность он хочет
            приобрести. Однако нередко сделки совершаются на основании эмоций,
            когда объект недвижимости просто понравился, чем-то приглянулся. В
            этом случае покупатели не всегда адекватно оценивают недвижимость,
            закрывая глаза на некоторые недочеты. Именно поэтому стоит взять с
            собой опытного специалиста, написать предварительный план осмотра
            квартиры, например, что является первостепенным, чтобы, покупая
            квартиру даже с недостатками иметь возможность получить скидку.
          </p>

          <div class="news-medium-img p-relative ratio4by3">
            <div class="page-banner-image p-absolute w-100 h-100">
              <img src="img/news-img-1.jpg" class="d-block img-cover" alt="Banner" />
            </div>
          </div>

          <p>
            Первое, что должно интересовать покупателя — это придомовая
            территория. Нужно проверять наличие парковки, если о ней указано,
            детских площадок. Также немаловажно состояние лестничных клеток,
            исправность лифта, особенно, если этажность квартиры высокая.
          </p>

          <p>
            При осмотре самой квартиры очень важна планировка, опытные
            специалисты могут определить, была ли перепланировка, только
            переступив порог, а если она была, то возникает вопрос: узаконена ли
            она в органах БТИ. Ведь в противном случае покупатель будет вынужден
            тратить дополнительные деньги и время. Если планировка квартиры не
            устраивает, ознакомьтесь, где расположены несущие стены и можно ли
            будет переделать все по вашему желанию.
          </p>

          <p>
            Осмотр жилого помещения лучше производить без мебели, так взгляд на
            него более объективен. В угловых квартирах необходимо проверять
            стены на наличие грибка и сырости, квартиры на последнем этаже — на
            наличие потеков с потолка, ведь крыша может протекать. Сыро может
            быть и на первом этаже, если подвал плохо вентилируется. Кстати
            сказать, наличие косметического предпродажного ремонта может
            свидетельствовать о сокрытии изъянов квартиры. Лучше всего, когда
            ремонт имеется и он «обжит» собственниками. Оцените звукоизоляцию
            квартиры в полной тишине, настолько слышен шум улицы, городской
            транспорт.
          </p>

          <div class="news-medium-img p-relative ratio4by3">
            <div class="page-banner-image p-absolute w-100 h-100">
              <img src="img/news-img-2.jpg" class="d-block img-cover" alt="Banner" />
            </div>
          </div>

          <p>
            Важным является осмотр коммуникаций: электропроводки, канализации,
            водопроводных труб, радиаторов отопления, особенно, если капитальный
            ремонт после покупки производиться не будет. Не менее важны
            показатели теплопроводности квартиры. И в этом случае время года
            играет не лучшую роль, ведь зимой вы можете оценить отопление
            квартиры, однако не сможете знать наверняка, насколько жарко в ней
            будет летом, и наоборот.
          </p>

          <p>
            Осмотру подлежат и наиболее дорогостоящие и трудоемкие места в плане
            ремонта: полы и потолки, межкомнатные и входные двери, стеклопакеты,
            сантехника, общее состояние ванны и кухни.
          </p>

          <p>
            Существует и такая немаловажная «инфраструктура» квартиры как
            хорошие соседи, и с ними лучше пообщаться. Ведь есть вероятность,
            что на лестничной клетке вы будете жить с алкоголиком, который любит
            шумные ночные пьянки, или соседи делают ремонт, тогда строительного
            шума в квартире и мусора на лестничной клетке не избежать, или над
            вами живет многодетная семья, тогда детский визг, плач и крик станут
            надолго спутником вашей жизни.
          </p>

          <p>
            При выборе квартиры невозможно предугадать все, однако опытные
            риелторы нашего агентства могут дать немало важных советов в
            контексте рассматриваемых вариантов собственности. Наиболее
            настораживающим для покупателя должна стать цена квартиры
            значительно ниже рыночной, именно таким образом продают имущество
            мошенники, - торопясь и за низкую цену.
          </p>

          <p>
            Статью подготовил эксперт в области недвижимости, руководитель
            отдела продажи агентства «PREMIER HOUSE» Хикматуллаев Анвар.
          </p>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "../../components/BreadCrumb";
import { mapGetters } from "vuex";

export default {
  components: {
    BreadCrumb
  },
  data() {
    return {
      post: null
    }
  },
  computed: {
    ...mapGetters({
      news: 'news/posts'
    }),
    currentPost() {
      return this.news.filter(e => e.id == this.$route.query.id)[0];
    }
  }
};
</script>

<style lang="scss" scoped>
  .news-text-wrap p {
    white-space: pre-line;
  }
</style>
